module.exports = __webpack_public_path__ + "img/brand-telegram.4dc351c3.svg";